<template>
    <div v-if="crmFileNo">
        {{ crmFileNo }}
    </div>
    <div v-else>
        <hts-form-button
            size="mini"
            color="success"
            class="!inline-flex"
            :loading="crmSyncing"
            @click="syncCrm">
            Bắt đầu đồng bộ
        </hts-form-button>
    </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const crmSyncing = ref(false)
const orderId = computed(() => params?.value?.data?._id)
const crmFileNo = computed(() => params?.value?.data?.crmFileNo)
const syncCrm = () => {
  crmSyncing.value = true

  $api($url.order.order.syncCrm, { uriParams: { ID: orderId.value } })
    .then(({ data }: any) => {
      crmSyncing.value = false
      const resData: any = data.value
      if (resData.success) {
        const orderData = resData.data || {}
        Object.assign(params?.value?.data, orderData)
      }
    })
    .catch(() => {
      crmSyncing.value = false
    })
}
</script>
